<template>
    <div>
        <SfeDialog

            :is-modal-open="modalVisible"
            :hasCloseIcon="showCloseModalIcon"
            :size="modalSize"
            :width="widthValue"
            animation="scale"
            :closeOnOverlayClick="closeOnClickOut"
            @close:modal="closeModal"
            class="general-overflow-wrap"
        >
            <template #header v-if="showDefaultAttributes">
                <div class="d-flex align-items-center">
                    <div v-if="hasHeaderIcon" class="mr-1">
                        <slot name="trigger"></slot>
                    </div>
                    <div>
                        <p class="mb-0 fw-600 fs-20" v-html="title"></p>
                        <p v-if="subTitle" class="mb-0 fw-400 fs-14 text-muted" v-html="subTitle"></p>
                    </div>
                </div>
                <SfeDivider v-if="showLineDivider" class="mt-3"/>
            </template>

            <template #body>
                <div :style="{overflowY: overFlowStyles.overflowY, maxHeight: overFlowStyles.maxHeight}">
                    <slot></slot>
                </div>
            </template>

            <template #footer v-if="showFooter">
                <slot name="modalFooter"></slot>
            </template>
        </SfeDialog>
    </div>
</template>

<script>

export default {
    // This component has been registered globally and it can be used anywhre without being imported.
    name: 'ModalWithSlot',
    emits: ['close:modal'],
    props: {
        modalContentMaxHeight: {
            type: String,
            default: '70vh'
        },
        modalContentOverflowY: {
            type: String,
            default: 'auto'
        },
        useOverflow: {
            type: Boolean,
            default: false, // this is set to false by default because setting it to true is affecting the content of the modal in most places. So wherever the content of the modal is expected to be large, it can be set to true. For example: ScheduleInterview component. 
            description: `Can be turned on when the modal is expected to have large information in it.`
        },
        modalSize: {
            type: String,
            default: 'lg'
        },
        hasHeaderIcon: {
            type: Boolean,
            default: false 
        },
        showModal: {
            type: Boolean,
            default: false 
        },

        closeOnClickOut: {
            type: Boolean,
            default: false 
        },

        showFooter: {
            type: Boolean,
            default: false 
        },

        showDefaultAttributes: {
            type: Boolean,
            default: true 
        },

        showLineDivider: {
            type: Boolean,
            default: true 
        },

        showCloseModalIcon: {
            type: Boolean,
            default: true 
        },

        title: {
            type: String,
            default: '' 
        },

        subTitle: {
            type: String,
            default: '' 
        },
        widthValue: {
            type: String,
            default: '' 
        }
    },
    data() {
        return { 
            modalVisible: false,
        }
    },
    mounted() {
        this.modalVisible = this.showModal
    },
    watch: {
        showModal:{
            immediate: true,
            handler(newValue){
                this.modalVisible = newValue
            }
        },
    },
    computed: {
        overFlowStyles() {
            if(this.useOverflow) {
                return {
                    overflowY: this.modalContentOverflowY,
                    maxHeight: this.modalContentMaxHeight
                }
            }
            return '';
        }
    },
    methods: {
        // openModal() {
        //     this.modalVisible = true
        // },
        closeModal() {
            this.modalVisible = false
            this.$emit('close:modal');
        },
},
           
}
</script>

<style scoped>
    ::v-deep(.modal-body) {
        padding: 0 !important;
    }
    ::v-deep(.modal-content) {
        border-radius: 1rem !important;
        border: none !important;
    }
    .general-overflow-wrap {
        overflow: hidden
    }
</style>